import React, { ComponentProps } from "react";
import Flex from "../Flex";
import Text from "../Text";
import ProgressBar from "../ProgressBar";
import Box from "../Box";
import Button from "../Button";
import InfoTip from "../Tooltip/InfoTip";
import { TooltipDirection } from "../Tooltip/TooltipTypes";

type Props = {
  title: string; // aria
  current: string;
  max: string;
  unit: string;
  tooltip?: string | React.ReactNode;
  action?: Partial<ComponentProps<typeof Button>>;
} & React.ComponentProps<typeof Flex>;

const UsageBar: React.FC<Props> = ({
  title,
  current,
  max,
  unit = "",
  tooltip = null,
  action = null,
  ...positioning
}) => {
  const currentNum = Number(current);
  const maxNum = Number(max);
  return (
    <Flex flexDirection="column" gap="4px" {...positioning}>
      <Flex justifyContent="space-between">
        <Flex gap="4px" alignItems="center">
          <Text font="ui.regularBold">{current}</Text>
          <Text>
            / {max} {unit}
          </Text>
          {tooltip && (
            <InfoTip direction={TooltipDirection.Right} interactive={false}>
              {tooltip}
            </InfoTip>
          )}
        </Flex>
        {action && <Button buttonStyle="tertiary" size="small" text="Increase Usage" {...action} />}
      </Flex>
      <Box>
        <ProgressBar
          current={currentNum}
          max={maxNum}
          fullColor={currentNum > maxNum ? "warning" : "info"}
          aria-label={`${title} usage: ${current} of ${max}`}
        />
      </Box>
    </Flex>
  );
};

export default UsageBar;
